export const DEVICE_PIN_LENGTH = 6;
export const DEVICE_NAME_MIN_LENGTH = 3;
export const DEVICE_NAME_MAX_LENGTH = 20;
